import { WithAccountId } from '@mews-commander/types';
import { PaymentPlanDetailResult } from '@mews-commander/data-access';
import { Grid } from '@optimus-web/core';
import { WithPaymentPlanId } from '../../tables/PaymentPlans/types';
import { PaymentPlanDetailsOverviewTable } from '../../tables/PaymentPlanPaymentsOverview/PaymentPlanDetailsOverviewTable';
import { PaymentPlanDetailsViewDetailSection } from './PaymentPlanDetailsViewDetailSection';

interface Props extends WithAccountId, WithPaymentPlanId {
    detail: PaymentPlanDetailResult;
}

export const PaymentPlanDetailsViewContent = ({ detail, accountId, paymentPlanId }: Props) => (
    <Grid height="100%" templateColumns="1fr 2fr" tabletMax={{ templateColumns: 'auto' }} columnGap="500" rowGap="200">
        <PaymentPlanDetailsViewDetailSection detail={detail} accountId={accountId} />
        <PaymentPlanDetailsOverviewTable paymentPlanId={paymentPlanId} accountId={accountId} />
    </Grid>
);
